<template>
    <div class="fullPage">
        <img src="../../../assets/image/banner/banner3.jpg" alt class="fullWidth"/>
        <div class="main-center main-top">
            <!--发票信息查询-->
            <el-tabs type="border-card">
                <el-tab-pane :label="$t('invoiceApplication.title')" class="searchComposite">
                    <div>
                        <div class="flex flex-space-around">
                            <!--发票号-->
                            <div class="inputName">
                                <span class="inputName-title">{{$t("invoiceApplication.invoiceNo")}}</span>
                                <el-input v-model="invoiceNo" :placeholder="$t('common.pleaseEnter')"
                                          clearable/>
                            </div>
                            <!--发票抬头-->
                            <div class="inputName">
                                <span class="inputName-title">{{$t("invoiceApplication.invoiceHeader")}}</span>
                                <el-input v-model="payer" :placeholder="$t('common.pleaseEnter')"
                                          clearable/>
                            </div>
                            <!--开票日期从-->
                            <div class="inputName">
                                <span class="inputName-title">{{$t("invoiceApplication.issuedDateFrom")}}</span>
                                <el-date-picker v-model="search.issuedDateFrom" type="date" class="dateInput"
                                                :placeholder="$t('common.pleaseSelectDate')"/>
                            </div>
                            <!--开票日期到-->
                            <div class="inputName">
                                <span class="inputName-title">{{$t("invoiceApplication.issuedDateTo")}}</span>
                                <el-date-picker v-model="search.issuedDateTo" type="date" class="dateInput"
                                                :placeholder="$t('common.pleaseSelectDate')"/>
                            </div>
                        </div>
                        <div class="flex flex-space-around topMargin">
                            <!--发票币别-->
                            <div class="inputName">
                                <span class="inputName-title">{{$t("invoiceApplication.currency")}}</span>
                                <el-select v-model="search.currency" clearable
                                           :placeholder="$t('common.pleaseSelect')"
                                           @focus="currencyCodeFocus">
                                    <el-option
                                            v-for="item in currencyOptions"
                                            :key="item.currencyCode"
                                            :label="item.currencyCode"
                                            :value="item.currencyCode">
                                    </el-option>
                                </el-select>
                            </div>
                            <!--合计金额(小写)-->
                            <div class="inputName">
                                <span class="inputName-title">{{$t("invoiceApplication.totalAmount")}}</span>
                                <el-input v-model="totalAmount"
                                          :placeholder="$t('common.pleaseEnter')"
                                          clearable/>
                            </div>
                            <!--发票状态-->
                            <div class="inputName">
                                <span class="inputName-title">{{$t("invoiceApplication.isCancelled")}}</span>
                                <el-select v-model="search.isCancelled" clearable
                                           :placeholder="$t('common.pleaseSelect')">
                                    <el-option
                                            v-for="item in isCancelledOptions"
                                            :key="item.codeValue"
                                            :label="getDisplayValue(item)"
                                            :value="item.codeValue">
                                        <span style="float: left">{{item.displayValueCn}}</span>
                                        <span style="float: right; color: #8492a6; font-size: 13px">{{item.displayValue}}</span>
                                    </el-option>
                                </el-select>
                            </div>
                            <!--发票类型-->
                            <div class="inputName">
                                <span class="inputName-title">{{$t("invoiceApplication.invoiceType")}}</span>
                                <el-select v-model="search.invoiceType" clearable
                                           :placeholder="$t('common.pleaseSelect')">
                                    <el-option
                                            v-for="item in invoiceTypeOptions"
                                            :key="item.codeValue"
                                            :label="getDisplayValue(item)"
                                            :value="item.codeValue">
                                        <span style="float: left">{{item.displayValueCn}}</span>
                                        <span style="float: right; color: #8492a6; font-size: 13px">{{item.displayValue}}</span>
                                    </el-option>
                                </el-select>
                            </div>
                        </div>
                        <div class="flex flex-space-around topMargin">
                            <!--提(运)单号-->
                            <div class="inputName">
                                <span class="inputName-title">{{$t("invoiceApplication.BusinessNo")}}</span>
                                <el-input v-model="blNo"
                                          :placeholder="$t('common.pleaseEnter')"
                                          clearable/>
                            </div>
                            <!--对账单号-->
                            <div class="inputName">
                                <span class="inputName-title">{{$t("invoiceApplication.ledgerCompNo")}}</span>
                                <el-input v-model="ledgerCompNo"
                                          :placeholder="$t('common.pleaseEnter')"
                                          clearable/>
                            </div>
                            <!--有无快递单号-->
                            <div class="inputName">
                                <el-checkbox v-model="search.hasNoExpressNumber" style="float: contour">{{$t("invoiceApplication.hasNoExpressNumber")}}</el-checkbox>
                            </div>
                            <div class="searchBtn">
                                <!--查询按钮-->
                                <el-button type="primary" icon="el-icon-search"
                                           @click="searchBtnClick">
                                    {{searchButton}}
                                </el-button>
                                <!--重置按钮-->
                                <el-button icon="el-icon-refresh"
                                           @click="resetBtnClick">
                                    {{resetButton}}
                                </el-button>
                            </div>
                        </div>
                    </div>
                </el-tab-pane>
            </el-tabs>
            <!--查询结果-->
            <div class="contentListCom">
                <result-bar>
                    <div slot="resultRight">
                        <!--全选-->
                        <el-button icon="el-icon-my-selectAll" @click="checkAllBtnClick(true)">
                            {{selectAll}}
                        </el-button>
                        <!--反选-->
                        <el-button icon="el-icon-my-selectInverse" @click="checkAllBtnClick(false)">
                            {{selectInverse}}
                        </el-button>
                        <!--反选-->
                        <el-button icon="el-icon-delete-solid" @click="deleteBtnClick">
                            {{deleteButton}}
                        </el-button>
                        <!--提交-->
                        <el-button icon="el-icon-s-promotion" @click="submitBtnClick">
                            {{$t("invoiceApplication.submit")}}
                        </el-button>
                        <vxe-switch v-model="showViewFlag" style="margin-left: 5px"
                                    open-label="common.cardView" close-label="common.tableView"
                                    open-icon="el-icon-notebook-2" close-icon="vxe-icon-table"
                                    open-value="card" close-value="table" @change="handleViewStyle">
                        </vxe-switch>
                    </div>
                </result-bar>
                <!--无数据组件-->
                <div v-if="showNoDataView || tableInvoiceDocData.length === 0" class="noData">
                    <no-data-view/>
                </div>

                <div class="contentListCom" v-else>
                    <!--展开视图-->
                    <div class="oneContent" v-for="(data,index) in tableInvoiceDocData" :key="index" v-if="showViewFlag==='card'">
                        <template>
                            <div class="top overflow">
                                <template>
                                    <template>
                                        <!--多选控件-->
                                        <el-checkbox class="checkOne l" v-model="data.checked" :key="index"
                                                     @change="checkOneMethod(index,data.checked)"></el-checkbox>
                                        <!--开票日期-->
                                        <p class="listContent l">
                                            <span class="firstSpan">{{index+1}}.{{$t("invoiceApplication.issuedDate")}}：</span>
                                            <span class="secondSpan blueColor">{{data.issuedDate}}</span>
                                        </p>
                                        <!--发票类型-->
                                        <p class="listContent l">
                                            <span class="firstSpan">{{$t("invoiceApplication.invoiceType")}}：</span>
                                            <span class="secondSpan">{{getInvoiceTypeDisplayValue(data)}}</span>
                                        </p>
                                    </template>
                                    <!--查看明细按钮-->
                                    <el-button class="normalListButton r red-button feeDetail" size="small"
                                               icon="el-icon-edit" @click="editBtnClick(data)">
                                        {{$t("invoiceApplication.feeDetail")}}
                                    </el-button>
                                </template>
                            </div>
                            <div class="center flexDiv">
                                <!--发票状态图标-->
                                <!--未提交-->
                                <div class="typeImg invoiceNotSubmittedImg" v-show="getCurLanguage() != 'en' && data.isCancelled == 0"/>
                                <div class="typeImg invoiceNotSubmittedEnImg" v-show="getCurLanguage() == 'en' && data.isCancelled == 0"/>
                                <!--已作废-->
                                <div class="typeImg invoiceCancelledImg" v-show="getCurLanguage() != 'en' && data.isCancelled == 1"/>
                                <div class="typeImg invoiceCancelledEnImg" v-show="getCurLanguage() == 'en' && data.isCancelled == 1"/>
                                <!--已红冲-->
                                <div class="typeImg invoiceRedRushedImg" v-show="getCurLanguage() != 'en' && data.isCancelled == 2"/>
                                <div class="typeImg invoiceRedRushedEnImg" v-show="getCurLanguage() == 'en' && data.isCancelled == 2"/>
                                <!--已提交-->
                                <div class="typeImg invoiceSubmittedImg" v-show="getCurLanguage() != 'en' && data.isCancelled == 3"/>
                                <div class="typeImg invoiceSubmittedEnImg" v-show="getCurLanguage() == 'en' && data.isCancelled == 3"/>
                                <!--已开票-->
                                <div class="typeImg invoiceIssuedImg" v-show="getCurLanguage() != 'en' && data.isCancelled == 4"/>
                                <div class="typeImg invoiceIssuedEnImg" v-show="getCurLanguage() == 'en' && data.isCancelled == 4"/>
                                <!--申请作废-->
                                <div class="typeImg invoiceApplyCancelledImg" v-show="getCurLanguage() != 'en' && data.isCancelled == 5"/>
                                <div class="typeImg invoiceApplyCancelledEnImg" v-show="getCurLanguage() == 'en' && data.isCancelled == 5"/>
                                <!--申请红冲-->
                                <div class="typeImg invoiceApplyRedRushImg" v-show="getCurLanguage() != 'en' && data.isCancelled == 6"/>
                                <div class="typeImg invoiceApplyRedRushEnImg" v-show="getCurLanguage() == 'en' && data.isCancelled == 6"/>
                                <!--已锁定-->
                                <div class="typeImg invoiceLockedImg" v-show="getCurLanguage() != 'en' && data.isCancelled == 7"/>
                                <div class="typeImg invoiceLockedEnImg" v-show="getCurLanguage() == 'en' && data.isCancelled == 7"/>
                                <!--申请退回-->
                                <div class="typeImg invoiceLockedImg" v-show="getCurLanguage() != 'en' && data.isCancelled == 8"/>
                                <div class="typeImg invoiceLockedEnImg" v-show="getCurLanguage() == 'en' && data.isCancelled == 8"/>
                                <el-descriptions style="margin-right: 150px" size="medium" :column=4>
                                    <!--发票号-->
                                    <el-descriptions-item :label="$t('invoiceApplication.invoiceNo')">{{data.invoiceNo}}</el-descriptions-item>
                                    <!--快递单号-->
                                    <el-descriptions-item :label="$t('invoiceApplication.trackingNumber')">{{data.expressNumber}}</el-descriptions-item>
                                    <!--发票抬头-->
                                    <el-descriptions-item :label="$t('invoiceApplication.invoiceHeader')">
                                        <descriptionsTooltip :value="data.payer"
                                                             :subValue="getSimplyContent(data.payer)"
                                                             :maxLength="maxLength"></descriptionsTooltip>
                                    </el-descriptions-item>
                                    <!--付款单位-->
                                    <el-descriptions-item :label="$t('invoiceApplication.payerName')">
                                        <descriptionsTooltip :value="data.payerName"
                                                             :subValue="getSimplyContent(data.payerName)"
                                                             :maxLength="maxLength"></descriptionsTooltip>
                                    </el-descriptions-item>
                                    <!--发票币别-->
                                    <el-descriptions-item :label="$t('invoiceApplication.currency')">
                                        <el-tag size="small" v-if="data.currency === 'CNY'">{{data.currency}}</el-tag>
                                        <el-tag size="small" class="blue_tag" v-else>{{data.currency}}</el-tag>
                                    </el-descriptions-item>
                                    <!--合计金额(小写)-->
                                    <el-descriptions-item :label="$t('invoiceApplication.totalAmount')">{{data.totalAmount}}</el-descriptions-item>
                                    <!--原币-->
                                    <el-descriptions-item :label="$t('invoiceApplication.quoteCurrency')">
                                        <el-tag size="small" type="info">{{data.quoteCurrency}}</el-tag>
                                    </el-descriptions-item>
                                    <!--原币金额-->
                                    <el-descriptions-item :label="$t('invoiceApplication.quoteAmount')">{{data.quoteAmount}}</el-descriptions-item>
                                    <!--是否电票-->
                                    <el-descriptions-item :label="$t('invoiceApplication.isInvoice')">{{data.electronicInvoiceFlag == 1 ? 'YES' : 'NO'}}</el-descriptions-item>
                                    <!--关联发票号-->
                                    <el-descriptions-item :label="$t('invoiceApplication.relationInvoiceNo')">{{data.relationInvoiceNo}}</el-descriptions-item>
                                    <!--关联开票日期-->
                                    <el-descriptions-item :label="$t('invoiceApplication.relationIssuedDate')">{{data.relationIssuedDate}}</el-descriptions-item>
                                    <!--提(运)单号-->
                                    <el-descriptions-item :label="$t('invoiceApplication.BusinessNo')">{{data.blNo}}</el-descriptions-item>
                                </el-descriptions>
                            </div>
                        </template>
                        <div class="bottom overflow">
                            <!--备注-->
                            <div class="l flexDiv leftMessage">
                                <p class="documentValid fontWeight msg">{{$t("invoiceApplication.remark")}}：{{data.remark}}</p>
                            </div>
                            <div class="r flexDiv">
                                <template>
                                    <!--发票下载-->
                                    <el-button class="normalListButton" style="height: 70%; margin-top: 4px"
                                               type="primary" icon="el-icon-download" size="small"
                                               @click="invoiceDownload(data)">{{$t("invoiceApplication.invoiceDownload")}}
                                    </el-button>
                                    <!--提交-->
                                    <el-button class="normalListButton" style="height: 70%; margin-top: 4px"
                                               type="success" icon="el-icon-upload" size="small"
                                               @click="submitOneBtnClick(data)">{{$t("invoiceApplication.submit")}}</el-button>
                                    <!--删除-->
                                    <el-button class="normalListButton" style="height: 70%; margin-top: 4px"
                                               type="info" icon="el-icon-delete-solid" size="small"
                                               @click="deleteOneBtnClick(data)">{{$t("invoiceApplication.delete")}}</el-button>
                                </template>
                            </div>
                        </div>
                    </div>
                    <!--发票数据表格pagination分页条-->
                    <div class="pagination" v-if="showViewFlag==='card'">
                        <div>
                            <el-pagination background layout="total,sizes,slot,prev, pager, next"
                                           max-height="600"
                                           :page-size="pageSize" :pager-count="pageCount"
                                           :page-sizes="[10, 20, 50, 100, 200]" :total="total"
                                           :current-page="pageNum"
                                           @size-change="handleSizeChange"
                                           @current-change="handleCurrentChange"/>
                        </div>
                    </div>

                    <!--表格视图-->
                    <div class="mainTable" v-if="showViewFlag==='table'">
                        <vxe-grid show-overflow
                                  ref="tableInvoiceDocData" class="vxeTable"
                                  height="500" size="small"
                                  :row-config="{isCurrent: true, isHover: true}"
                                  :column-config="{resizable: true}"
                                  :export-config="{}"
                                  :checkbox-config="{checkStrictly: true}"
                                  @checkbox-change="handleTableInvoiceChecked"
                                  resizable
                                  keep-source
                                  show-footer
                                  :data="tableInvoiceDocData"
                                  :columns="tableColumn"
                                  :toolbar-config="tableToolbar">
                            <!--顶端工具栏插槽-->
                            <template #toolbar_buttons>
                                <vxe-button @click="exportDataEvent" status="primary" type="text" icon="vxe-icon-file-excel" style="margin-left: 10px">
                                    {{exportDataButton}}</vxe-button>
                                <vxe-button @click="$refs.tableInvoiceDocData.hideColumn($refs.tableInvoiceDocData.getColumnByField('menu'))" status="primary" type="text" icon="vxe-icon-eye-fill-close" style="margin-left: 10px">
                                    {{$t('common.menuHide')}}</vxe-button>
                                <vxe-button @click="$refs.tableInvoiceDocData.showColumn($refs.tableInvoiceDocData.getColumnByField('menu'))" status="primary" type="text" icon="vxe-icon-eye-fill" style="margin-left: 10px">
                                    {{$t('common.menuShow')}}</vxe-button>
                            </template>
                            <!--发票状态插槽-->
                            <template #column_isCancelled="{ row }">
                                <!--未提交-->
                                <span class="yellowColor" v-if="row.isCancelled == 0">{{getInvoiceStatusDisplay(row)}}</span>
                                <!--已作废-->
                                <span class="redColor" v-else-if="row.isCancelled == 1">{{getInvoiceStatusDisplay(row)}}</span>
                                <!--已红冲-->
                                <span class="grayColor" v-else-if="row.isCancelled == 2">{{getInvoiceStatusDisplay(row)}}</span>
                                <!--已提交-->
                                <span class="greenColor" v-else-if="row.isCancelled == 3">{{getInvoiceStatusDisplay(row)}}</span>
                                <!--已开票-->
                                <span class="purpleColor" v-else-if="row.isCancelled == 4">{{getInvoiceStatusDisplay(row)}}</span>
                                <!--申请作废-->
                                <span class="yellowColor" v-else-if="row.isCancelled == 5">{{getInvoiceStatusDisplay(row)}}</span>
                                <!--申请红冲-->
                                <span class="yellowColor" v-else-if="row.isCancelled == 6">{{getInvoiceStatusDisplay(row)}}</span>
                                <!--已锁定-->
                                <span class="blueColor" v-else-if="row.isCancelled == 7">{{getInvoiceStatusDisplay(row)}}</span>
                                <!--默认-->
                                <span v-else>{{getInvoiceStatusDisplay(row)}}</span>
                            </template>
                            <!--发票币别插槽-->
                            <template #column_currency="{ row }">
                                <el-tag size="small" v-if="row.currency === 'CNY'">{{row.currency}}</el-tag>
                                <el-tag size="small" class="blue_tag" v-else>{{row.currency}}</el-tag>
                            </template>
                            <!--原币插槽-->
                            <template #column_quoteCurrency="{ row }">
                                <el-tag size="small" type="info">{{row.quoteCurrency}}</el-tag>
                            </template>
                            <!--是否电票插槽-->
                            <template #column_electronicInvoiceFlag="{ row }">
                                <span>{{row.electronicInvoiceFlag == 1 ? 'YES' : 'NO'}}</span>
                            </template>
                            <!--发票类型插槽-->
                            <template #column_invoiceType="{ row }">
                                <span>{{getInvoiceTypeDisplayValue(row)}}</span>
                            </template>
                            <!--操作按钮插槽-->
                            <template #operate_default="{ row }">
                                <!--明细按钮-->
                                <el-tooltip class="item" effect="dark" :content="viewDetails" placement="bottom-start">
                                    <el-button style="line-height: 15px; height: 22px; width: 22px"
                                               size="mini" type="primary" icon="el-icon-edit" circle @click="editBtnClick(row)"></el-button>
                                </el-tooltip>
                                <!--删除按钮-->
                                <el-tooltip class="item" effect="dark" :content="deleteButton" placement="bottom-start">
                                    <el-button style="line-height: 15px; height: 22px; width: 22px"
                                               size="mini" type="info" icon="el-icon-delete" circle @click="deleteOneBtnClick(row)"></el-button>
                                </el-tooltip>
                                <!--提交按钮-->
                                <el-button size="mini" style="margin-top: 4px; color: #67C23A" type="text" icon="el-icon-s-promotion"
                                           @click="submitOneBtnClick(row)">{{$t("invoiceApplication.submit")}}</el-button>
                                <!--发票下载按钮-->
                                <el-button size="mini" style="margin-top: 4px" type="text" icon="vxe-icon-download"
                                           @click="invoiceDownload(row)">{{$t("invoiceApplication.invoiceDownload")}}</el-button>
                            </template>
                            <template #pager>
                                <vxe-pager
                                        :layouts="['PrevPage', 'JumpNumber', 'NextPage', 'FullJump', 'Sizes', 'Total']"
                                        :current-page.sync="pageNum"
                                        :page-size.sync="pageSize"
                                        :page-sizes="[10, 20, 50, 100, 200]"
                                        :total="total"
                                        @page-change="handleTablePageChange">
                                </vxe-pager>
                            </template>
                        </vxe-grid>
                    </div>

                </div>
            </div>
        </div>

        <!--页面底部组件-->
        <div class="footerSpan">
            <span></span>
        </div>
    </div>
</template>

<script>
    import noDataView from "@/components/noDataView";
    import resultBar from "@/components/resultBar";

    export default {
        name: "invoiceApplication",
        computed: {
            // 发票号查询条件
            invoiceNo: {
                get: function () {
                    return this.search.invoiceNo;
                },
                set: function (val) {
                    this.search.invoiceNo = val.toUpperCase();
                }
            },
            // 发票抬头查询条件
            payer: {
                get: function () {
                    return this.search.payer;
                },
                set: function (val) {
                    this.search.payer = val.toUpperCase();
                }
            },
            // 合计金额(小写)查询条件
            totalAmount: {
                get: function () {
                    return this.search.totalAmount;
                },
                set: function (val) {
                    let formatNumber = "";
                    //去掉非法字符
                    val = (val + '').replace(/[^\d.]/g, '')
                    // 必须保证第一个为数字而不是. 输入第一位为.默认补充0
                        .replace(/^\./g, '0.')
                        // 保证只有出现一个.而没有多个.
                        .replace(/\.{2,}/g, '.')
                        // 保证.只出现一次，而不能出现两次以上
                        .replace('.', '$#$')
                        .replace(/\./g, '')
                        .replace('$#$', '.');
                    let strs = val.split('.');
                    if (strs.length === 1) {
                        formatNumber = strs[0];
                    } else if (strs.length > 1) {
                        if (strs[1].length > 3) {
                            strs[1] = strs[1].substring(0, 3);
                        }
                        formatNumber = strs.join('.');
                    }
                    this.search.totalAmount = formatNumber;
                }
            },
            // 提(运)单号查询条件
            blNo: {
                get: function () {
                    return this.search.blNo;
                },
                set: function (val) {
                    this.search.blNo = val.toUpperCase();
                }
            },
            // 对账单号查询条件
            ledgerCompNo: {
                get: function () {
                    return this.search.ledgerCompNo;
                },
                set: function (val) {
                    this.search.ledgerCompNo = val.toUpperCase();
                }
            },
            selectAll() {//全选
                return this.$t("common.selectAll");
            },
            selectInverse() {//反选
                return this.$t("common.selectInverse");
            },
            exportDataButton() {
                return this.$t('common.exportTableData');
            },
            deleteButton() {//删除
                return this.$t("common.deleteButton");
            },
            searchButton() {//查询按钮
                return this.$t("common.searchButton");
            },
            resetButton() {//重置按钮
                return this.$t("common.resetButton");
            },
            viewDetails() {
                return this.$t('common.viewDetails');
            },
        },
        components: {
            noDataView,
            resultBar
        },
        data() {
            return {
                isSearchClick: false,       //控制查询按钮是否重复点击
                customerChargeUploadShow: false,  //控制第三方收退费excel上传框是否显示
                validationInfoShow: false,  //控制校验信息表格是否显示
                showNoDataView: false,
                showViewFlag: "card",       //控制数据是否展开显示 card：卡片  table：表格
                maxLength: 20,
                allAlign: 'center',// vxe-table表格默认文字居中

                currencyOptions: [],
                invoiceTypeOptions: [               // 发票类型下拉值
                    {codeValue: "ZP", displayValueCn: "纸普", displayValue: "PAPER ORDINARY"},
                    {codeValue: "XS", displayValueCn: "形式", displayValue: "PROFORMA"},
                    {codeValue: "QD", displayValueCn: "全电", displayValue: "ALL ELECTRIC"},
                    {codeValue: "DP", displayValueCn: "电普", displayValue: "ELECTRIC ORDINARY"}
                ],
                isCancelledOptions: [               // 发票状态下拉值
                    {codeValue: 0, displayValueCn: "未提交", displayValue: "NOT SUBMITTED"},
                    {codeValue: 1, displayValueCn: "已作废", displayValue: "CANCELLED"},
                    {codeValue: 2, displayValueCn: "已红冲", displayValue: "RED RUSHED"},
                    {codeValue: 3, displayValueCn: "已提交", displayValue: "SUBMITTED"},
                    {codeValue: 4, displayValueCn: "已开票", displayValue: "ISSUED"},
                    {codeValue: 5, displayValueCn: "申请作废 ", displayValue: "APPLY CANCELLATION"},
                    {codeValue: 6, displayValueCn: "申请红冲", displayValue: "APPLY RED RUSH"},
                    {codeValue: 7, displayValueCn: "已锁定", displayValue: "LOCKED"},
                    {codeValue: 8, displayValueCn: "申请退回", displayValue: "APPLYING GO BACK"},
                ],

                //查询参数
                search: {
                    invoiceNo: "",          //发票号
                    payer: "",              //发票抬头
                    issuedDateFrom: "",     //开票日期从
                    issuedDateTo: "",       //开票日期到
                    currency: "",           //发票币别
                    totalAmount: null,        //合计金额(小写)
                    isCancelled: "",        //发票状态
                    invoiceType: "",        //发票类型
                    blNo: "",               //提(运)单号
                    ledgerCompNo: "",       //对账单号
                    hasNoExpressNumber: false, //无快递单号
                },
                // 【发票数据表格】
                tableInvoiceDocData: [],
                tableInvoiceDocDataChecked: [], // 发票数据表格多选列表
                tableToolbar: {
                    perfect: true,
                    zoom: true,
                    custom: true,
                    slots: {
                        buttons: 'toolbar_buttons'
                    }
                },
                tableColumn: [
                    { align: 'center' ,type: 'checkbox', width: 40 },
                    { align: 'center' ,type: 'seq', title: 'confirmFreight.no', width: 60, sortable: true, },//序号
                    { align: 'center' ,field: 'isCancelled', title: 'invoiceApplication.isCancelled', minWidth: 150, sortable: true,
                        slots: {   //该处展示自定义插槽，可以将数据封装到想用的组件里，视觉效果更佳
                            default: 'column_isCancelled'
                        }
                    },//发票状态
                    { align: 'center' ,field: 'invoiceNo', title: 'invoiceApplication.invoiceNo', minWidth: 120, sortable: true, },//发票号
                    { align: 'center' ,field: 'payer', title: 'invoiceApplication.invoiceHeader', minWidth: 180, sortable: true, },//发票抬头
                    // { align: 'center' ,field: 'payerName', title: 'invoiceApplication.payerName', minWidth: 180, sortable: true, },//付款单位
                    { align: 'center' ,field: 'issuedDate', title: 'invoiceApplication.issuedDate', minWidth: 180, sortable: true, },//开票日期
                    { align: 'center' ,field: 'totalAmount', title: 'invoiceApplication.totalAmount', minWidth: 150, sortable: true, },//合计金额(小写)
                    { align: 'center' ,field: 'currency', title: 'invoiceApplication.currency', minWidth: 150, sortable: true,
                        slots: {
                            default: 'column_currency'
                        }
                    },//发票币别
                    { align: 'center' ,field: 'quoteAmount', title: 'invoiceApplication.quoteAmount', minWidth: 150, sortable: true,  },//原币金额
                    { align: 'center' ,field: 'quoteCurrency', title: 'invoiceApplication.quoteCurrency', minWidth: 140, sortable: true,
                        slots: {   //该处展示自定义插槽，可以将数据封装到想用的组件里，视觉效果更佳
                            default: 'column_quoteCurrency'
                        }
                    },//原币
                    { align: 'center' ,field: 'electronicInvoiceFlag', title: 'invoiceApplication.isInvoice', minWidth: 120, sortable: true,
                        slots: {   //该处展示自定义插槽，可以将数据封装到想用的组件里，视觉效果更佳
                            default: 'column_electronicInvoiceFlag'
                        }
                    },//是否电票
                    { align: 'center' ,field: 'invoiceType', title: 'invoiceApplication.invoiceType', minWidth: 220, sortable: true,
                        slots: {   //该处展示自定义插槽，可以将数据封装到想用的组件里，视觉效果更佳
                            default: 'column_invoiceType'
                        }
                    },//发票类型
                    { align: 'center' ,field: 'blNo', title: 'invoiceApplication.BusinessNo', minWidth: 180, sortable: true,  },//提(运)单号
                    { align: 'center' ,field: 'expressNumber', title: 'invoiceApplication.trackingNumber', minWidth: 180, sortable: true,  },//快递单号
                    { align: 'center' ,field: 'relationInvoiceNo', title: 'invoiceApplication.relationInvoiceNo', minWidth: 160, sortable: true,  },//关联发票号
                    { align: 'center' ,field: 'relationIssuedDate', title: 'invoiceApplication.relationIssuedDate', minWidth: 170, sortable: true,  },//关联开票日期
                    { align: 'center' ,field: 'remark', title: 'invoiceApplication.remark', minWidth: 300, sortable: true,  },//备注
                    { align: 'center' ,field: 'menu', title: 'common.menuColumn', minWidth: 290, fixed: 'right',
                        titlePrefix: {
                            icon: 'el-icon-s-tools'
                        },
                        slots: {
                            default: 'operate_default'
                        }
                    }
                ],

                // 发票数据分页参数
                pageCount: 5,
                pageNum: 1,
                pageSize: 20,
                total: 0,
            };
        },
        methods: {
            /************************************ 工具栏按钮点击事件 ************************************/
            /**
             * 发票查询按钮点击
             */
            searchBtnClick() {
                if (this.isSearchClick) {//上一次查询未结束时不允许重复发起请求
                    return;
                }
                this.isSearchClick = true;

                // 声明一个loading对象
                this.loadingtuo = this.$loading({
                    lock: true, // 设置加载时是否锁屏,锁屏状态加载区域无法操作
                    text: this.$t('message.searching'),     // 加载动画的文字
                    spinner: 'el-icon-loading',             // 引入的loading图标
                    background: "rgb(0,0,0,0.1)",
                    target: document.querySelector(".searchComposite") // 设置加载动画区域
                });
                let that = this;
                this.axios({
                    method: 'post',
                    url: '/api/invoiceDoc/invoiceDocPageQuery',
                    data: {
                        invoiceNo: this.search.invoiceNo,          //发票号
                        payer: this.search.payer,                   //发票抬头
                        issuedDateFrom: this.search.issuedDateFrom === "" ? "" : this.formatDate(
                            {date: this.search.issuedDateFrom, formatStr: 'yyyy-MM-dd'}
                        ),          //开票日期从
                        issuedDateTo: this.search.issuedDateTo === "" ? "" : this.formatDate(
                            {date: this.search.issuedDateTo, formatStr: 'yyyy-MM-dd'}
                        ),          //开票日期到
                        currency: this.search.currency,             //发票币别
                        totalAmount: this.search.totalAmount,       //合计金额(小写)
                        isCancelled: this.search.isCancelled,       //发票状态
                        invoiceType: this.search.invoiceType,       //发票类型
                        blNo: this.search.blNo,                     //提(运)单号
                        ledgerCompNo: this.search.ledgerCompNo,     //对账单号
                        hasNoExpressNumber: this.search.hasNoExpressNumber, //无快递单号
                        pageNum: this.pageNum,
                        pageSize: this.pageSize
                    },
                    headers: {
                        'Accept-language': localStorage.getItem("locale")
                    }
                }).then(response => {
                    that.loadingtuo.close();
                    this.responseCode = response.data.backMessage;
                    if (response.data.backCode === "200") {
                        this.showNoDataView = false;
                        let data = response.data.object.list;
                        this.tableInvoiceDocData = this.refreshChecked(data);
                        this.total = response.data.object.total;
                    } else {
                        this.showMessage(false, this.responseCode, "error");
                        if (response.data.backCode === "207"){
                            // 当前未登录，跳转到登录页面
                            this.$router.push({
                                path: '/homePage',
                                query: {redirect: "/invoiceApplication"} // 将跳转的路由path作为参数，登录成功后跳转到该路由
                            });
                        }
                    }
                    this.isSearchClick = false;//设置查询按钮为可点击状态,允许再次发起请求
                }).catch(error => {
                    that.loadingtuo.close();//关闭进度条
                    if (error.data) {
                        this.responseCode = error.data.backMessage;
                        this.showMessage(false, this.responseCode, "error");
                    } else {
                        this.showMessage(false, error, "error");
                    }
                    this.isSearchClick = false;//设置查询按钮为可点击状态,允许再次发起请求
                });
            },
            /**
             * 重置按钮点击
             */
            resetBtnClick() {
                this.search.invoiceNo = "";
                this.search.payer = "";
                this.search.issuedDateFrom = "";
                this.search.issuedDateTo = "";
                this.search.currency = "";
                this.search.totalAmount = "";
                this.search.isCancelled = "";
                this.search.invoiceType = "";
                this.search.blNo = "";
                this.search.ledgerCompNo = "";
                this.search.hasNoExpressNumber = false;
            },
            /**
             * 全选/反选按钮点击
             */
            checkAllBtnClick(isCheck){
                // 先清空发票多选列表
                this.tableInvoiceDocDataChecked = [];
                if(isCheck){
                    // 全选
                    this.tableInvoiceDocData.forEach((item,index)=>{
                        item.checked = true;
                        this.checkOneMethod(index, true)
                    });
                }else{
                    // 反选
                    this.tableInvoiceDocData.forEach((item,index)=>{
                        let cur = item.checked;
                        item.checked = !cur;
                        this.checkOneMethod(index, !cur)
                    })
                }
            },
            /**
             * 发票删除
             */
            deleteBtnClick(){
                var invoiceDocIds=[];
                console.log(this.tableInvoiceDocDataChecked);
                this.tableInvoiceDocDataChecked.forEach(item=>{
                    invoiceDocIds.push(item.invoiceDocId);
                });
                // 校验是否勾选数据
                if(invoiceDocIds.length <= 0){
                    this.showMessage(false, this.$t('message.noDataSelected'), "warning");
                    return;
                }
                // 删除操作
                this.axios({
                    method: 'post',
                    url: '/api/invoiceDoc/invoiceDocDelete',
                    data: {
                        invoiceDocIds: JSON.stringify(invoiceDocIds),
                    },
                    headers: {
                        'Accept-language': localStorage.getItem("locale")
                    }
                }).then(response => {
                    this.responseCode = response.data.backMessage;
                    if (response.data.backCode === "200") {
                        this.showMessage(true, this.$t("message.guaranteeDeleteSucceed"), "success");
                        this.searchBtnClick();
                    } else {
                        this.showMessage(false, this.responseCode, "error");
                    }
                }).catch(error => {
                    if (error.data) {
                        this.responseCode = error.data.backMessage;
                        this.showMessage(false, this.responseCode, "error");
                    } else {
                        this.showMessage(false, error, "error");
                    }
                });
            },
            deleteOneBtnClick(data) {
                var invoiceDocIds=[];
                // 校验发票是否为未提交状态
                if (data.isCancelled != null && data.isCancelled != 0) {
                    this.$alert(this.$t("message.invoiceNotDelete"), this.$t("billsManagement.message.deleteFailed") , {
                        confirmButtonText: this.$t("common.okButton")
                    });
                    return;
                }
                this.$confirm(this.$t("message.deleteCurrentInvoice"), this.$t("common.pleaseConfirm") , {
                    distinguishCancelAndClose: true,
                    confirmButtonText: this.$t("common.deleteButton"),
                    cancelButtonText: this.$t("common.cancelButton")
                }).then(() => {
                    invoiceDocIds.push(data.invoiceDocId);
                    this.axios({
                        method: 'post',
                        url: '/api/invoiceDoc/invoiceDocDelete',
                        data: {
                            invoiceDocIds: JSON.stringify(invoiceDocIds),
                        },
                        headers: {
                            'Accept-language': localStorage.getItem("locale")
                        }
                    }).then(response => {
                        this.responseCode = response.data.backMessage;
                        if (response.data.backCode === "200") {
                            this.showMessage(true, this.$t("message.guaranteeDeleteSucceed"), "success");
                            this.searchBtnClick();
                        } else {
                            this.showMessage(false, this.responseCode, "error");
                        }
                    }).catch(error => {
                        if (error.data) {
                            this.responseCode = error.data.backMessage;
                            this.showMessage(false, this.responseCode, "error");
                        } else {
                            this.showMessage(false, error, "error");
                        }
                    });
                })
            },

            /**
             * 发票批量下载
             */
            invoiceDownloads(){
                var invoiceIds = [];
                this.tableInvoiceDocDataChecked.forEach(item=>{
                    invoiceIds.push(item.invoiceDocId);
                });
                // 校验是否勾选数据
                if(invoiceIds.length <= 0){
                    this.showMessage(false, this.$t('message.noDataSelected'), "warning");
                    return;
                }
                this.downloads(invoiceIds);
            },
            /**
             * 发票单票下载
             */
            invoiceDownload(invoice){
                var invoiceIds=[];
                invoiceIds.push(invoice.invoiceDocId);

                this.downloads(invoiceIds);
            },
            downloads(invoiceIds){
                let invoiceNoAndUrls = new Map();
                let failedBls = [];
                this.axios({
                    method: 'post',
                    url: '/api/invoiceDoc/invoiceDownload',

                    data: {
                        statementOfAccountIds: JSON.stringify(invoiceIds),
                    },
                    headers: {
                        'Accept-language': localStorage.getItem("locale")
                    }
                }).then(response => {
                    this.responseCode = response.data.backMessage;
                    if (response.data.backCode === "200") {
                        invoiceNoAndUrls = response.data.object;
                        for(var key in invoiceNoAndUrls){
                            if(invoiceNoAndUrls[key] == null){
                                failedBls.push(key);
                            }

                            this.fileDownload(invoiceNoAndUrls[key],key);
                        }
                        // 若存在下载失败，提示下载失败发票信息
                        if(failedBls.length > 0){
                            this.$alert(this.$t('message.blBatchDownloadFailed',
                                                {blNo: failedBls.join('，')}),
                                                 this.$t('bookingSpace.other.downloadFailed'), {
                                confirmButtonText: this.$t('common.okButton')
                            });
                        }
                    } else if(response.data.backCode === "204") {//下载失败,发票现在还没上传附件
                        this.$alert(this.$t('message.blBatchDownloadFailed',
                            {blNo: failedBls.join('，')}),
                            this.$t('message.invoiceDownloadErrorTitle'), {
                                confirmButtonText: this.$t('common.okButton')
                            });
                    } else{
                        this.showMessage(false, this.responseCode, "error");
                    }
                }).catch(error => {
                    if (error.data) {
                        this.responseCode = error.data.backMessage;
                        this.showMessage(false, this.responseCode, "error");
                    } else {
                        this.showMessage(false, error, "error");
                    }
                });
            },

            //通过url下载文件
            async fileDownload(url,fileName) {
                // let link = document.createElement('a');
                // link.href = url;
                // link.download = fileName; //加上下载的文件名
                // if (url.indexOf('?') === -1) { //这步不加应该也好使，但我没试
                //     url += '?download'
                //     console.log(1)
                // }
                // link.click();
                // link.remove();
                window.open(url, '_blank');
            },



            /**
             * 发票提交
             */
            submitBtnClick() {
                // 获取当前时间（小时）
                let nowDate = new Date();
                let nowHours = nowDate.getHours();

                var invoiceDocIds=[];
                let allowCommit = true;
                this.tableInvoiceDocDataChecked.forEach(item=>{
                    // 校验发票提交状态是否为未提交状态
                    if(item.isCancelled != null && item.isCancelled != 0){
                        allowCommit = false;
                    }
                    invoiceDocIds.push(item.invoiceDocId);
                });
                // 校验是否勾选数据
                if(invoiceDocIds.length <= 0){
                    this.showMessage(false, this.$t('message.noDataSelected'), "warning");
                    return;
                }

                // 校验发票提交状态是否为未提交状态
                if(!allowCommit){
                    this.showMessage(false, this.$t('message.invoiceNotAllowed2Commit'), "warning");
                    return;
                }

                // 提交操作
                let confirmFlag = false;

                this.$confirm(this.$t("message.ConfirmSubmission"), this.$t("common.pleaseConfirm") , {
                    distinguishCancelAndClose: true,
                    confirmButtonText:  this.$t("invoiceApplication.submit"),
                    cancelButtonText: this.$t("common.cancelButton")
                }).then(() => {
                    // 校验当前时间超过北京时间16:00，开票日期是否确定更新为明天？
                    if(nowHours > 16){
                        this.$confirm(this.$t("message.SetTomorrow"), this.$t("common.pleaseConfirm") , {
                            distinguishCancelAndClose: true,
                            confirmButtonText:  this.$t("common.okButton"),
                            cancelButtonText: this.$t("common.cancelButton")
                        }).then(() => {
                            confirmFlag = true;
                        }).catch(action => {
                            //取消
                            if (action === 'cancel') {
                                console.log(action);
                            }
                        })
                    } else{
                        confirmFlag = true;
                    }

                    if(confirmFlag){
                        // 发送请求到后端
                        this.axios({
                            method: "post",
                            url: "/api/invoiceDoc/invoiceDocSubmit",
                            data: {
                                invoiceDocIds: JSON.stringify(invoiceDocIds)
                            },
                            headers: {
                                'Accept-language': localStorage.getItem("locale"),
                                'Content-type': "application/json;charset=utf-8"
                            }
                        }).then(response => {
                            this.responseCode = response.data.backMessage;
                            if (response.data.backCode === "200") {
                                this.showMessage(false, this.$t("invoiceApplication.SuccessfullySubmitted"), "success");
                                this.searchBtnClick();
                            } else {
                                this.showMessage(false, this.responseCode, "error");
                            }
                        }).catch(error => {
                            if (error.data) {
                                this.responseCode = error.data.backMessage;
                                this.showMessage(false, this.responseCode, "error");
                            } else {
                                this.showMessage(false, error, "error");
                            }
                        });
                    }
                }).catch(action => {
                    //取消
                    if (action === 'cancel') {
                        console.log(action);
                    }
                })
            },
            submitOneBtnClick(data) {
                // 校验发票提交状态是否为未提交状态
                if(data.isCancelled != null && data.isCancelled != 0){
                    this.showMessage(false, this.$t('message.invoiceSubmitted'), "warning");
                    return;
                }

                // 校验当前操作账号是否为发票申请人


                // 获取当前时间（小时）
                let nowDate = new Date();
                let nowHours = nowDate.getHours();
                let invoiceDocIds = [];
                invoiceDocIds.push(data.invoiceDocId);
                let confirmFlag = false;

                this.$confirm(this.$t("message.ConfirmSubmission"), this.$t("common.pleaseConfirm") , {
                    distinguishCancelAndClose: true,
                    confirmButtonText: this.$t("invoiceApplication.submit"),
                    cancelButtonText:  this.$t("common.cancelButton")
                }).then(() => {
                    // 校验当前时间超过北京时间16:00，开票日期是否确定更新为明天？
                    if(nowHours > 16){
                        this.$confirm(this.$t("message.SetTomorrow"), this.$t("common.pleaseConfirm") , {
                            distinguishCancelAndClose: true,
                            confirmButtonText: this.$t("common.okButton"),
                            cancelButtonText: this.$t("common.cancelButton")
                        }).then(() => {
                            // 发送请求到后端
                            this.axios({
                                method: "post",
                                url: "/api/invoiceDoc/invoiceDocSubmit",
                                data: {
                                    invoiceDocIds: JSON.stringify(invoiceDocIds)
                                },
                                headers: {
                                    'Accept-language': localStorage.getItem("locale"),
                                    'Content-type': "application/json;charset=utf-8"
                                }
                            }).then(response => {
                                this.responseCode = response.data.backMessage;
                                if (response.data.backCode === "200") {
                                    this.showMessage(false, this.$t("invoiceApplication.SuccessfullySubmitted"), "success");
                                    this.searchBtnClick();
                                } else {
                                    this.showMessage(false, this.responseCode, "error");
                                }
                            }).catch(error => {
                                if (error.data) {
                                    this.responseCode = error.data.backMessage;
                                    this.showMessage(false, this.responseCode, "error");
                                } else {
                                    this.showMessage(false, error, "error");
                                }
                            });
                        }).catch(action => {
                            //取消
                            if (action === 'cancel') {
                                console.log(action);
                            }
                        })
                    } else{
                        // 发送请求到后端
                        this.axios({
                            method: "post",
                            url: "/api/invoiceDoc/invoiceDocSubmit",
                            data: {
                                invoiceDocIds: JSON.stringify(invoiceDocIds)
                            },
                            headers: {
                                'Accept-language': localStorage.getItem("locale"),
                                'Content-type': "application/json;charset=utf-8"
                            }
                        }).then(response => {
                            this.responseCode = response.data.backMessage;
                            if (response.data.backCode === "200") {
                                this.showMessage(false, this.$t("invoiceApplication.SuccessfullySubmitted"), "success");
                                this.searchBtnClick();
                            } else {
                                this.showMessage(false, this.responseCode, "error");
                            }
                        }).catch(error => {
                            if (error.data) {
                                this.responseCode = error.data.backMessage;
                                this.showMessage(false, this.responseCode, "error");
                            } else {
                                this.showMessage(false, error, "error");
                            }
                        });
                    }
                }).catch(action => {
                    //取消
                    if (action === 'cancel') {
                        console.log(action);
                    }
                })
            },
            /**
             * 发票明细按钮点击
             */
            editBtnClick(data) {
                // this.$router.push({
                //     name: 'invoiceDetails',
                //     params: {
                //         invoiceDocInfo: data
                //     }
                // });
                var route = this.$router.resolve({
                    name: 'invoiceDetails',
                });
                // 将传递参数存到session中
                sessionStorage.setItem("PASSING_PARAMETERS", JSON.stringify(data));
                sessionStorage.removeItem("PASSING_PARAMETERS_1");
                // 打开对账单明细页面
                window.open(route.href, '_blank')
            },

            /************************************ 表格多选事件 *************************************/
            /**
             * 发票记录勾选事件，将选中发票添加进勾选列表中
             */
            checkOneMethod(index, type) {
                let curData = this.tableInvoiceDocData[index];
                if (type) {//选中
                    this.tableInvoiceDocDataChecked.push(curData);
                    // 新增表格视图下全选控制
                    if(this.$refs.tableInvoiceDocData){
                        this.$refs.tableInvoiceDocData.setCheckboxRow(curData, type);
                    }
                } else {//取消选中
                    this.tableInvoiceDocDataChecked.forEach((item, index) => {
                        if (item.invoiceDocId === curData.invoiceDocId) {
                            this.tableInvoiceDocDataChecked.splice(index, 1);
                        }
                    });
                    // 新增表格视图下反选控制
                    if(this.$refs.tableInvoiceDocData){
                        this.$refs.tableInvoiceDocData.toggleCheckboxRow(curData);
                    }
                }
            },
            /**
             * 发票数据表格勾选事件，将表格中选中发票添加进勾选列表中
             */
            handleTableInvoiceChecked({checked}) {
                // 清空数据checked状态
                this.tableInvoiceDocData.forEach((item)=>{
                    item.checked = false;
                });
                // 先清空发票多选列表
                this.tableInvoiceDocDataChecked = [];
                // 更新表格勾选的费用信息
                this.tableInvoiceDocDataChecked = this.$refs.tableInvoiceDocData.getCheckboxRecords();
            },
            /**
             * 表格数据导出
             */
            exportDataEvent () {
                this.$refs.tableInvoiceDocData.openExport({ types: ['csv'] })
            },

            /************************************ 表格分页工具 *************************************/
            /**
             * 发票数据表格分页条 *
             */
            handleDemand() {
                this.searchBtnClick();
            },
            handleSizeChange(val) {
                this.pageSize = val;
                this.handleDemand();
                this.$emit("backTop");
            },
            handleCurrentChange(val) {
                this.pageNum = val;
                this.handleDemand(1);
                this.$emit("backTop");
            },
            /**
             * 发票数据表格分页条(表格视图)
             */
            handleTablePageChange ({ currentPage, pageSize }) {
                this.pageNum = currentPage;
                this.pageSize = pageSize;
                this.searchBtnClick();
            },

            /************************************ 行记录点击事件 ************************************/

            /************************************ 基础数据下拉框赋值 ************************************/
            /**
             * 币种下拉选赋值
             */
            currencyCodeFocus() {
                const _this = this;
                this.axios({
                    method: "get",
                    url: "/api/codedict/getCurrencyCodeList",
                    headers: {
                        'Accept-language': localStorage.getItem("locale")
                    }
                }).then(function (response) {
                    _this.currencyOptions = response.data.object
                }).catch(error => {
                    if (error.data) {
                        this.responseCode = error.data.backMessage;
                        this.showMessage(false, this.responseCode, "error");
                    } else {
                        this.showMessage(false, error, "error");
                    }
                });
            },

            /************************************ 其他事件 *************************************/
            /**
             * 调整视图切换开关change方法
             */
            handleViewStyle(data) {
                // 切换展示风格
                this.showViewFlag = data.value;
                // 将展示风格存到session中
                sessionStorage.setItem("VIEW_STYLE", this.showViewFlag);
            },
            formatNumber(number, decimals) {
                if (number !== "") {
                    let formatNumber = "";
                    //去掉非法字符
                    number = (number + '').replace(/[^\d.]/g, '')
                    // 必须保证第一个为数字而不是. 输入第一位为.默认补充0
                        .replace(/^\./g, '0.')
                        // 保证只有出现一个.而没有多个.
                        .replace(/\.{2,}/g, '.')
                        // 保证.只出现一次，而不能出现两次以上
                        .replace('.', '$#$')
                        .replace(/\./g, '')
                        .replace('$#$', '.');
                    let strs = number.split('.');
                    if (strs.length === 1) {
                        formatNumber = strs[0];
                    } else if (strs.length > 1) {
                        strs[1] += "00";
                        if (strs[1].length > decimals) {
                            strs[1] = strs[1].substring(0, decimals);
                        }
                        formatNumber = strs.join('.');
                    }
                    return formatNumber;
                }
            },
            /**
             * 刷新表格记录选中状态，恢复未选中状态
             */
            refreshChecked(tableData){
                // 清空发票表格数据多选列表
                this.tableInvoiceDocDataChecked = [];
                if(tableData == null || tableData.length <= 0){
                    return [];
                }
                tableData.forEach((data)=>{
                    data.checked = false;
                    // 处理数字格式
                    data.totalAmount = this.formatNumber(data.totalAmount,2);
                });
                return tableData;
            },
            /**
             * 长文本获取缩略内容显示，鼠标悬停时弹出文字提示，显示全部内容
             */
            getSimplyContent(content) {
                if(content == null || content === ""){
                    return content;
                }
                // 获取传入value的长度（英文字符占1位，中文字符占2位）
                let contentLength = this.calculateContentLength(content);

                // 校验长度是否超过最大长度
                if(contentLength > this.maxLength){
                    // 截取显示25位
                    while (this.calculateContentLength(content) > this.maxLength) {
                        content = content.substr(0, content.length - 1);
                    }
                    content += "...";
                }
                return content;
            },
            /**
             * 计算传入字符串占位数（英文及标点符号占1位，中文占两位）
             */
            calculateContentLength(content){
                let contentLength = 0;
                if(content != null || content !== ""){
                    // 获取字符串长度
                    let cnReg = /([\u4e00-\u9fa5]|[\u3000-\u303F]|[\uFF00-\uFF60])/g;
                    let mat = content.match(cnReg);
                    if (mat) {
                        contentLength = mat.length * 2 + (content.length - mat.length);
                    } else{
                        contentLength = content.length;
                    }
                }
                return contentLength;
            },
            /**
             * 获取当前时区
             */
            getCurLanguage() {
                return localStorage.getItem('locale');
            },
            /**
             * 获取发票状态显示值
             */
            getInvoiceStatusDisplay(data){
                let value = {};
                this.isCancelledOptions.forEach((option) => {
                    if (option.codeValue == data.isCancelled) {
                        value = option;
                    }
                });

                if (value !== {}) {
                    return localStorage.getItem('locale') == 'en' ? value.displayValue : value.displayValueCn;
                } else {
                    return data.isCancelled;
                }
            },
            /**
             * 获取发票类型显示值
             */
            getInvoiceTypeDisplayValue(item) {
                let value = {};
                this.invoiceTypeOptions.forEach((option) => {
                    if (option.codeValue == item.invoiceType) {
                        value = option;
                    }
                });

                if (value !== {}) {
                    return localStorage.getItem('locale') == 'en' ? value.displayValue : value.displayValueCn;
                } else {
                    return item.invoiceType;
                }
            },
            getDisplayValue(item) {
                return localStorage.getItem('locale') == 'en' ? item.displayValue : item.displayValueCn;
            },

            /************************************ 页面初始化 ************************************/

        },
        mounted() {
            // 页面渲染完成后初始化数据展示风格
            if(sessionStorage.getItem("VIEW_STYLE") != null){
                this.showViewFlag = sessionStorage.getItem("VIEW_STYLE");
            } else{
                this.showViewFlag = "card";//默认展示卡片视图
            }
        },
        created() {
            this.$parent.updateHeaderAside();
        },
        activated() {
            //当估价单表格有数据时需自动查询最新数据
            if (this.tableInvoiceDocData.length > 0) {
                this.searchBtnClick();
            }
        }
    };
</script>
<style rel="stylesheet/scss" lang="scss" scoped>
    @import "../../../assets/scss/base";
    @import "../../../assets/scss/public";

    /*列表展示*/
    .contentListCom{min-height: 264px;}
    .contentListCom .oneContent{width: 100%;margin-bottom: 10px;margin-top: 5px;}
    .contentListCom .top{height: 40px;border: 1px solid #E8E8E8;background: #E9E9E9;padding-left: 18px;line-height: 40px;}
    .contentListCom .center{padding: 15px 0 15px 17px;border: 1px solid #E8E8E8;background: #FFFFFF;border-top: none}
    .contentListCom .bottom{height: 40px;border: 1px solid #E8E8E8;background: #FFFFFF;border-top: none;line-height: 40px;}
    .contentListCom .listContentLong{width: 330px;overflow: hidden;white-space: nowrap;text-overflow: ellipsis;color: #606266;margin-top: 5px;}
    .contentListCom .listContentShort{width: 200px;overflow: hidden;white-space: nowrap;text-overflow: ellipsis;color: #606266;margin-top: 5px;}
    .contentListCom .listContent{width: 250px;overflow: hidden;white-space: nowrap;text-overflow: ellipsis;color: #606266;margin-top: 5px;}
    .contentListCom .listContent .thirdSpan{margin-left: 5px;display: inline-block}
    .contentListCom .center .listContent{font-size: 15px;height: 20px;line-height: 20px;}
    .contentListCom .center .listContent .secondSpan{color: #031B28;}
    .contentListCom .center .shortListContent{width: 200px}
    .contentListCom .center .longListContent{width: 300px}
    .contentListCom .listContent.rightMoney{text-align: right;margin-right: 5px}
    /*列表展示的单选和费用明细按钮*/
    .contentListCom .top{position: relative}
    .contentListCom .top .evaluateBtn{margin-left: 10px;border-radius: 4px}
    .contentListCom .top .feeDetail{position: absolute;right: 5px;top: 5px}
    .contentListCom .top .checkOne{margin-right: 5px;margin-top: 5px}
    /*列表展示图标位置*/
    .contentListCom .center{position: relative}
    .typeImg{ width: 160px;height: 125px;position: absolute;right: 10px;top: 6px;}
    .flexDiv{display: flex;flex-wrap: wrap;}
    /*列表展示协议价订单等内容展示*/
    .leftMessage .msg{line-height: 39px;margin-left: 10px;color: #606266;overflow: hidden;white-space: nowrap;text-overflow: ellipsis;}
    .xyj{width: 72px;color: #BC1920!important;}
    .auditMes{max-width: 95px;}
    .documentValid{margin-top: 5px;font-weight: bold}
    .documentValidLong{width: 280px;margin-top: 5px;font-weight: bold}
    .flexDiv .normalListButton{margin-right: 3px;}
    .flexDiv .normalListButton1{margin-right: 3px;margin-top: 2px}
    .flexDiv .normalListBlueButton{margin-right: 3px;background: $colorJ;color: $colorA;border: 1px solid #F6F6F6;}
    .flexDiv .normalListRedButton{margin-right: 3px;background: $colorC;color: $colorA;border: 1px solid #F6F6F6;}
    .hasBack{background-color: #567E8D;color: #fff}
    .hasBack:hover{background-color: #354953!important;color: #fff!important;}

    .flexDiv .normalListButton{margin-right: 3px;}
    /*其他常用*/
    .visCom{visibility: hidden}
    .overflow{overflow: hidden}
    .l{float: left}
    .r{float: right}
    .flexDiv{display: flex;flex-wrap: wrap;}

    .jdt_nr {
        width: 50%;
        margin: 0 auto;
        z-index: 10001;
        top: 50%;
        margin-top: -31px;
        text-align: center;
        position: absolute;
        margin-left: 25%
    }

    .inputName {
        flex: 1;
        margin: 0 5px;
    }

    .topMargin {
        margin-top: 20px;
    }

    .searchBtn {
        display: flex;
        flex: 1;
        justify-content: flex-end;
        margin: 0 5px;
    }

    .voyageIcon {
        margin-left: 10px;
        margin-top: 5px;
        width: 30px;
        height: 30px;
        border: 1px solid #0091ff;
        border-radius: 4px;
    }

    .noData {
        height: 100%;
        margin: 15px 0;
        background-color: #ffffff;
    }

    .searchList {
        margin: 15px 0;
    }

    /deep/ .el-input-group__prepend {
        background-color: #d9e3f0;
    }

    .popoverView {
        padding: 5px;
        background-color: #ffffff;
    }

    .popoverInner {
        margin: 5px;
        margin-top: 0;
    }

    .flex1 {
        flex: 1;
    }

    .boatBox {
        position: relative;

        .boatBox-list-box {
            min-width: 280px;
            position: absolute;
            left: 51px;
            top: 30px;
            background: $colorA;
            padding: 5px 10px;
            z-index: 100;
            border: 1px solid $colorE;
            font-size: $fontC;
            font-weight: 600;

            .boatBox-top {
                width: 100%;
                height: 20px;
                line-height: 20px;
                background: $colorB;
            }

            .left {
                width: 30%;
                margin-right: 4%;
            }

            .right {
                width: 66%;
            }

            ul {
                padding: 0;
                margin: 0;

                li {
                    border-bottom: 1px solid #e7f0fc;
                    padding: 4px 2px;
                }

                li:last-of-type {
                    border: none;
                }

                li:hover {
                    background: rgb(224, 240, 245);
                }
            }
        }
    }

    .el-upload{
        .el-upload-dragger{
            width: 700px;
        }
    }

    .cardTitle {
        margin-bottom: 10px;

        span {
            font-size: $fontC;
            color: $colorF;
            letter-spacing: 0;
            font-weight: 600;
            margin-left: 6px;
        }
    }

    .my-upload-demo ::v-deep .el-upload {
        .el-upload-dragger {
            background-color: #fff;
            border: 1px dashed #d9d9d9;
            border-radius: 6px;
            box-sizing: border-box;
            width: 800px;
            height: 180px;
            text-align: center;
            cursor: pointer;
            position: relative;
            overflow: hidden;
        }
    }

    /*未提交*/
    .invoiceNotSubmittedImg {
        background-image: url(../../../assets/image/invoiceNotSubmitted.jpg) !important;
        background-repeat: no-repeat;
    }
    .invoiceNotSubmittedEnImg {
        background-image: url(../../../assets/image/invoiceNotSubmittedEn.jpg) !important;
        background-repeat: no-repeat;
    }
    /*已作废*/
    .invoiceCancelledImg {
        background-image: url(../../../assets/image/invoiceCancelled.jpg) !important;
        background-repeat: no-repeat;
    }
    .invoiceCancelledEnImg {
        background-image: url(../../../assets/image/invoiceCancelledEn.jpg) !important;
        background-repeat: no-repeat;
    }
    /*已红冲*/
    .invoiceRedRushedImg {
        background-image: url(../../../assets/image/invoiceRedRushed.jpg) !important;
        background-repeat: no-repeat;
    }
    .invoiceRedRushedEnImg {
        background-image: url(../../../assets/image/invoiceRedRushedEn.jpg) !important;
        background-repeat: no-repeat;
    }
    /*已提交*/
    .invoiceSubmittedImg {
        background-image: url(../../../assets/image/invoiceSubmitted.jpg) !important;
        background-repeat: no-repeat;
    }
    .invoiceSubmittedEnImg {
        background-image: url(../../../assets/image/invoiceSubmittedEn.jpg) !important;
        background-repeat: no-repeat;
    }
    /*已开票*/
    .invoiceIssuedImg {
        background-image: url(../../../assets/image/invoiceIssued.jpg) !important;
        background-repeat: no-repeat;
    }
    .invoiceIssuedEnImg {
        background-image: url(../../../assets/image/invoiceIssuedEn.jpg) !important;
        background-repeat: no-repeat;
    }
    /*申请作废*/
    .invoiceApplyCancelledImg {
        background-image: url(../../../assets/image/invoiceApplyCancelled.jpg) !important;
        background-repeat: no-repeat;
    }
    .invoiceApplyCancelledEnImg {
        background-image: url(../../../assets/image/invoiceApplyCancelledEn.jpg) !important;
        background-repeat: no-repeat;
    }
    /*申请红冲*/
    .invoiceApplyRedRushImg {
        background-image: url(../../../assets/image/invoiceApplyRedRush.jpg) !important;
        background-repeat: no-repeat;
    }
    .invoiceApplyRedRushEnImg {
        background-image: url(../../../assets/image/invoiceApplyRedRushEn.jpg) !important;
        background-repeat: no-repeat;
    }
    /*已锁定*/
    .invoiceLockedImg {
        background-image: url(../../../assets/image/invoiceLocked.jpg) !important;
        background-repeat: no-repeat;
    }
    .invoiceLockedEnImg {
        background-image: url(../../../assets/image/invoiceLockedEn.jpg) !important;
        background-repeat: no-repeat;
    }
    /*申请退回*/
    .invoiceLockedImg {
        background-image: url(../../../assets/image/invoiceApplyingGoBack.png) !important;
        background-repeat: no-repeat;
    }
    .invoiceLockedEnImg {
        background-image: url(../../../assets/image/invoiceApplyingGoBackEn.png) !important;
        background-repeat: no-repeat;
    }

</style>
<style lang="scss">
    .el-tabs__content {
        background: #fff;
    }

    //全选icon
    .el-icon-my-selectAll {
        background: url('../../../assets/image/icon/selectAll.png') center center no-repeat;
        font-size: 16px;
        background-size: cover;
    }

    .el-icon-my-selectAll:before {
        content: "替";
        font-size: 16px;
        visibility: hidden;
    }

    //反选icon
    .el-icon-my-selectInverse {
        background: url('../../../assets/image/icon/selectInverse.png') center center no-repeat;
        font-size: 16px;
        background-size: cover;
    }

    .el-icon-my-selectInverse:before {
        content: "替";
        font-size: 16px;
        visibility: hidden;
    }

</style>